// extracted by extract-css-chunks-webpack-plugin
module.exports = {"embed":"css-qYQXs2yYTl"};